// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4cd860a8","453":"419a5d54","732":"f2fa3afe","977":"a6f63304"}[chunkId] + ".chunk.js";
};